export default function NotFoundPage() {
    return (
        <div className='text-3xl flex items-center justify-center h-[100vh] w-[100vw]'>見つかりません</div>
    );
}
